import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DashboardService } from '../../../services/dashboard/dashboard.service';
import { CategoriesEnum } from '../../../shared/models/app/info-enum';
import { DashboardProductBestSellingFilter } from './../../../shared/models/dashboard/dashboard-product-best-selling-filter';

function formatLocalDateISO(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0'); // 1..12
  const day = String(d.getDate()).padStart(2, '0'); // 01..31
  return `${y}-${m}-${day}`;
}

export const featuredProductsResolver: ResolveFn<any> = () => {
  const dashboardService = inject(DashboardService);

  const today = new Date();
  const start = new Date(today);
  start.setMonth(today.getMonth() - 2); // 2 meses para trás (mesmo dia)

  const filter = new DashboardProductBestSellingFilter();
  filter.categories = [
    CategoriesEnum.COBERTURAS_EM_POLICARBONATO,
    CategoriesEnum.KITS,
    CategoriesEnum.TOLDOS,
  ];
  filter.limit = 50;
  filter.startDate = formatLocalDateISO(start);
  filter.endDate = formatLocalDateISO(today);

  return dashboardService.bestSellingProducts(filter);
};
